// ** Styles
import '@styles/react/apps/app-roads.scss';
import Wizard from '../shared/Wizard';

const defaultValues = {
  title: '',
  description: '',
  status: 'initial',
  activity: 'initial',
  frases: [],
  cover: '',
  contents: [],
  tags: [],
  emotions: 0,
  relations: 0,
  transformation: 0,
  selfEsteem: 0,
  purpose: 0,
  gender: []
};

const NewEpisode = () => {
  return <Wizard editMode={false} defaultValues={defaultValues} />;
};

export default NewEpisode;
